import { API } from "../../config/api"

export default async (lang) => {
    try{
        const response = await fetch(`${API}/reviews/${lang}`)

        const {success,reviews} = await response.json()

        return {success,reviews}
    }catch(error){
        console.log(error)

        return {success:false}
    }
}